/**
 * 推荐 - 分类聚合
 * @author Kody
 */

import Api from '@umu/umu-api';
import { IListResponse } from '@umu/umu-types';
import { fetchData } from '@umu/umu-fetch';

import { ICourseResourceInfo, ICircleResourceInfo } from 'market/@marketCommon/interface/recommend';

export interface IRecommendByCategory {
    category_id: string;
    category_name: string;
    category_log: string;
    children: {
        group: ICourseResourceInfo[];
        circle: ICircleResourceInfo[];
    };
}

export const getCategoryRecommends = (): Promise<IListResponse<IRecommendByCategory>> => {
    return fetchData(Api.Path.MARKET_CATEGORY_RECOMMENDS, {
        category_type: 2,
    })
        .then((res: IListResponse<IRecommendByCategory>) => {
            return res;
        })
        .catch(() => {
            return {
                error_code: 0,
                data: {
                    list: [],
                },
            };
        });
};
